export class ReportSearch {
  public page?: string
  public size?: string
  public name?: string
  public createAtStart?: string
  public createAtEnd?: string
  public type?: string
  public customerServiceId?: string
  public sort?: string
  public excel?: boolean
  constructor(
    params: {
      page?: string
      size?: string
      name?: string
      createAtStart?: string
      createAtEnd?: string
      type?: string
      customerServiceId?: string
      sort?: string
      excel?: boolean
    } = {}
  ) {
    this.page = params.page || ''
    this.size = params.size || ''
    this.name = params.name || ''
    this.createAtStart = params.createAtStart || ''
    this.createAtEnd = params.createAtEnd || ''
    this.type = params.type || ''
    this.customerServiceId = params.customerServiceId || ''
    this.sort = params.sort || ''
    this.excel = params.excel || false
  }
}
